import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, notification } from "antd";
import { Row, Form, Input, Col, Select, Collapse, Popconfirm } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import Pagination from "../../common/Pagination/Pagination";
import "../../common/Pagination/Pagination.css";
import {
    MinusCircleTwoTone,
    PlusCircleTwoTone,
    DeleteOutlined,
} from "@ant-design/icons";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
import IngredientsApi from "../../common/Apis/IngredientsApi";

const Ingredients = () => {
    const { Content } = Layout;
    const { Panel } = Collapse;

    // ── Data ────────────────────────────────────────────────
    const [Ingredients, setIngredients] = React.useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    // ── Pagination ──────────────────────────────────────────
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [formPaginate] = Form.useForm();
    formPaginate.setFieldsValue({ paginate: pageSize });

    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

    // ── Fetch ───────────────────────────────────────────────
    const getIngredients = useCallback(() => {
        IngredientsApi.ListIngredients(0,100)
            .then((response) => {
                const list = (response.payloadDto || []).sort((a, b) => b.id - a.id);
                setIngredients(list);
                setTotalElements(list.length);
                setTotalPages(Math.ceil(list.length / pageSize));
                setCurrentPage(1);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [pageSize]);

    const [isLoading, setIsLoading] = useState(false);
    const PageLoading = useCallback(() => {
        setIsLoading(true);
        setTimeout(() => setIsLoading(false), 800);
    }, []);

    useEffect(() => {
        PageLoading();
        getIngredients();
    }, [getIngredients, PageLoading]);

    // ── Pagination handlers ─────────────────────────────────
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePageSizeChange = (value) => {
        setPageSize(value);
        setCurrentPage(1);
        formPaginate.setFieldsValue({ paginate: value });
        setTotalPages(Math.ceil(Ingredients.length / value));
    };

    // ── Filters ─────────────────────────────────────────────
    const formRef = useRef(null);
    const [filterIngredients, setFilterIngredients] = useState([
        { title: "", answerType: "", name: "" },
    ]);

    const handleAddfilterIngredient = () => {
        setFilterIngredients([
            ...filterIngredients,
            { title: "", answerType: "", name: "" },
        ]);
    };

    const handleRemovefilterIngredient = (FiltergetIngredientsIndex) => {
        const next = [...filterIngredients];              // ← fixed: use filterIngredients
        next.splice(FiltergetIngredientsIndex, 1);
        setFilterIngredients(next);
        if (FiltergetIngredientsIndex === 0) {
            getIngredients();
        }
    };

    const handleClear = () => {
        setIsLoading(true);
        getIngredients();
        setTimeout(() => setIsLoading(false), 800);
        setFilterIngredients([{ title: "", answerType: "", name: "" }]);
    };

    const handleSubmit = (data) => {
        setIsLoading(true);
        setTimeout(() => setIsLoading(false), 800);

        let singleLineString = filterIngredients
            .filter((obj) => obj.title && obj.answerType && obj.name)   // ← skip empty rows
            .map((obj) => {
                if (obj.answerType === "%") {
                    return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
                } else if (obj.answerType === "=") {
                    return `${obj.title}${obj.answerType}${obj.name}`;
                } else {
                    return `${obj.title}=${obj.name}`;
                }
            })
            .join("&");

        let filderData = window.btoa(
            "componentCode=INGREDIENTS&subTenant.id=" +
                decodedToken?.subTenantId +
                "&" +
                singleLineString
        );

        QuestionnairesApi.FilterQuestionsetNext(filderData, 0, pageSize)
            .then((response) => {
                const filtered = response.payloadDto || [];
                setIngredients(filtered);
                setTotalElements(filtered.length);
                setTotalPages(Math.ceil(filtered.length / pageSize));
                setCurrentPage(1);             // ← reset to first page
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleDeleteIngredients = (IngredientsID) => {
        IngredientsApi.DeleteIngredients(IngredientsID)
            .then(() => {
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
                    description: "Delete Successfully",
                    closeIcon: false,
                    duration: 3,
                    style: { backgroundColor: "#b3ffb3", color: "green" },
                });
                PageLoading();
                getIngredients();
            })
            .catch((err) => {
                if (err.apiError?.status) {
                    notification.open({
                        message: <span style={{ fontWeight: "bold" }}>Error</span>,
                        description: err.apiError.message,
                        closeIcon: false,
                        duration: 3,
                        style: { backgroundColor: "#fff2f0", color: "red" },
                    });
                }
            });
    };

    const handleChangeTitle = (i, value) => {
        const next = [...filterIngredients];
        next[i].title = value;
        setFilterIngredients(next);
    };
    const handleChangeAnswertype = (i, value) => {
        const next = [...filterIngredients];
        next[i].answerType = value;
        setFilterIngredients(next);
    };
    const handleChangename = (i, value) => {
        const next = [...filterIngredients];
        next[i].name = value;
        setFilterIngredients(next);
    };

    // ── Render ──────────────────────────────────────────────
    const paginatedData = Ingredients.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    const renderTableRows = () => {
        if (paginatedData.length > 0) {
            return paginatedData.map((item) => (
                <tr key={item?.id} className="text-center">
                    <td style={{ width: "20%" }} className="pt-3">
                        {item?.name}
                    </td>
                    <td style={{ width: "8%" }} className="pt-3">
                        {item?.ingredientsStatus}
                    </td>
                    <td style={{ width: "15%" }} className="pt-3 text-center">
                        <div
                            style={{
                                overflowX: "auto",
                                overflowY: "hidden",
                                whiteSpace: "nowrap",
                                maxWidth: "200px",
                                marginBottom: "10px",
                                marginTop: "-3px",
                                padding: "0px 0px 20px",
                                display: "block",
                            }}
                        >
                            {item?.batchCode || "-"}
                        </div>
                    </td>
                    <td style={{ width: "15%" }} className="pt-3 text-center">
                        {item?.openUBD ? formatDate(item?.openUBD) : "N/A"}
                    </td>
                    <td style={{ width: "20%" }}>
                        <div className="d-flex ">
                            <Link
                                to={`/masters/ingredients/edit-ingredients?id=${item?.id}`}
                                className={
                                    decodedToken?.permissions?.some(
                                        (permission) => permission?.authority === "EDIT_INGREDIENTS"
                                    )
                                        ? "btn btn-primary btn-save table-action icon-center w-100"
                                        : "d-none"
                                }
                            >
                                <EditOutlined />
                                Edit
                            </Link>
                            <Popconfirm
                                title="Are you sure ?"
                                description="Do you really want to delete this Ingredients ?"
                                okText="Yes"
                                onConfirm={() => handleDeleteIngredients(item.id)}
                                placement="topRight"
                                className="w-100"
                                cancelText="No"
                            >
                                <Link
                                    to={``}
                                    className={
                                        decodedToken?.permissions?.some(
                                            (permission) =>
                                                permission?.authority === "DELETE_INGREDIENTS"
                                        )
                                            ? "btn btn-primary btn-back table-action icon-center mx-1"
                                            : "d-none"
                                    }
                                >
                                    <DeleteOutlined />
                                    Delete
                                </Link>
                            </Popconfirm>
                        </div>
                    </td>
                </tr>
            ));
        } else {
            return (
                <tr className="text-center EmptyTable">
                    <td colSpan={6} className="text-center ">
                        <img
                            src="/assest/Images/emptyIcon.svg"
                            className="logo-png mt-3"
                            style={{ width: "10%" }}
                            alt=""
                        />
                        <br />
                        <Button
                            className="btn btn-primary btn-save m-0 my-2 mt-4 "
                            href={"/masters/ingredients/add-ingredients"}
                        >
                            Add Ingredients
                        </Button>
                    </td>
                </tr>
            );
        }
    };

    function formatDate(date) {
        const dateNew = parseInt(date, 10);
        const options = { day: "2-digit", month: "short", year: "numeric" };
        const formattedDate = new Date(dateNew).toLocaleDateString("en-US", options);
        const [month, day, year] = formattedDate.split(" ");
        const capitalizedMonth = month.toUpperCase();
        return `${day} ${capitalizedMonth} ${year}`;
    }

    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Sidebar />
            <Layout>
                <TopHeader />
                {isLoading && (
                    <div className="spinner-overlay" id="spinnerOverlay">
                        <div className="spinner"></div>
                    </div>
                )}
                <div style={{ padding: "20px", paddingBottom: "5px" }}>
                    <Form
                        ref={formRef}
                        name="nest-messages"
                        layout="vertical"
                        className="FormClass FilterForm"
                        onFinish={handleSubmit}
                    >
                        <Collapse>
                            <Panel
                                header={
                                    <h5 className="mb-0">
                                        <b>Filter</b>
                                    </h5>
                                }
                                key="1"
                            >
                                {filterIngredients.map((input, filterIngredientIndex) => (
                                    <div key={filterIngredientIndex}>
                                        <Row gutter={12} className="pt-2">
                                            <Col span={5}>
                                                <Form.Item
                                                    name={`title${filterIngredientIndex}`}
                                                    className="text-lable"
                                                    rules={[{ required: true, message: "Please Select" }]}
                                                >
                                                    <Select
                                                        className="control-Select"
                                                        placeholder="Filter By"
                                                        value={input.title}
                                                        onChange={(value) =>
                                                            handleChangeTitle(filterIngredientIndex, value)
                                                        }
                                                        options={[
                                                            { value: "name", label: "Ingredient" },
                                                            { value: "status", label: "Status" },
                                                            { value: "batchCode", label: "Batch Code" },
                                                            { value: "quantity", label: "Quantity" },
                                                        ]}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={4}>
                                                <Form.Item
                                                    name={`type${filterIngredientIndex}`}
                                                    className="text-lable"
                                                    rules={[{ required: true, message: "Please Select type." }]}
                                                >
                                                    <Select
                                                        className="control-Select mb-1"
                                                        placeholder="Condition"
                                                        onChange={(value) =>
                                                            handleChangeAnswertype(filterIngredientIndex, value)
                                                        }
                                                        options={
                                                            filterIngredients[filterIngredientIndex].title === "quantity"
                                                                ? [{ value: "=", label: "Equal" }]
                                                                : [
                                                                      { value: "%", label: "Matches with" },
                                                                      { value: "=", label: "Equals to" },
                                                                  ]
                                                        }
                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col span={5}>
                                                <Form.Item
                                                    name={`name${filterIngredientIndex}`}
                                                    className="text-lable"
                                                    rules={[{ required: true, message: "Please enter Text." }]}
                                                >
                                                    <Input
                                                        type="text"
                                                        onChange={(e) =>
                                                            handleChangename(filterIngredientIndex, e.target.value)
                                                        }
                                                        placeholder="Text"
                                                        className="control-input"
                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col span={8}>
                                                <Form.Item className="text-lable">
                                                    {filterIngredientIndex === 0 ? (
                                                        <Row gutter={23} className="mb-3">
                                                            <Col span={2} className="mx-0">
                                                                <Form.Item className="text-lable">
                                                                    <PlusCircleTwoTone
                                                                        onClick={handleAddfilterIngredient}
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={10}>
                                                                <Button
                                                                    type="primary"
                                                                    htmlType="submit"
                                                                    className="btn btn-primary btn-save table-action icon-center "
                                                                >
                                                                    Filter
                                                                </Button>
                                                            </Col>
                                                            <Col span={10}>
                                                                <Button
                                                                    type="reset"
                                                                    htmlType="reset"
                                                                    onClick={() => handleClear()}
                                                                    style={{ color: "#0b5ed7" }}
                                                                    className="btn btn-primary btn-back table-action icon-center"
                                                                >
                                                                    Clear
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    ) : (
                                                        <MinusCircleTwoTone
                                                            onClick={() =>
                                                                handleRemovefilterIngredient(filterIngredientIndex)
                                                            }
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </div>
                                ))}
                            </Panel>
                        </Collapse>
                    </Form>
                </div>

                <Content
                    className="form-content nav-content"
                    style={{ margin: "14px 16px 0", padding: "30px", background: "white" }}
                >
                    <div>
                        {/* Toolbar: Add + Page size */}
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            {paginatedData?.length > 0 && (
                                <Button
                                    className={
                                        decodedToken?.permissions?.some(
                                            (permission) => permission?.authority === "ADD_INGREDIENTS"
                                        )
                                            ? "btn btn-primary btn-save m-0 my-2"
                                            : "d-none"
                                    }
                                    href={"/masters/ingredients/add-ingredients"}
                                >
                                    Add Ingredients
                                </Button>
                            )}
                            <Form form={formPaginate}>
                                <Form.Item
                                    name="paginate"
                                    className="text-lable"
                                    style={{ width: "100px", marginBottom: 0 }}
                                >
                                    <Select
                                        className="control-Select"
                                        onChange={(value) => handlePageSizeChange(value)}
                                        options={[
                                            { value: 10, label: "10" },
                                            { value: 20, label: "20" },
                                            { value: 30, label: "30" },
                                            { value: 40, label: "40" },
                                            { value: 50, label: "50" },
                                            { value: 100, label: "100" },
                                        ]}
                                    />
                                </Form.Item>
                            </Form>
                        </div>

                        <table className="table users-table">
                            <thead>
                                <tr>
                                    <th>Ingredient</th>
                                    <th>Status</th>
                                    <th className="text-center">Batch Code</th>
                                    <th className="text-center">OUBD</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>{renderTableRows()}</tbody>
                        </table>

                        {paginatedData.length > 0 && (
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                                maxVisiblePages={5}
                                showPageInfo={true}
                                totalItems={totalElements}
                                pageSize={pageSize}
                            />
                        )}
                    </div>
                </Content>
            </Layout>
        </Layout>
    );
};

export default Ingredients;